import {
  FAR_TERRAIN_LENGTH_LIMITS_BY_RESOLUTION,
  INTERMEDIATE_TERRAIN_LENGTH_LIMITS,
  TREES_CONCAVE_ALPHA_MAX,
  TREES_MINIMAL_HEIGHT_MAX,
  TREES_MINIMAL_HEIGHT_VALIDATION_MIN,
  TREES_RADIUS_VALIDATION_MAX,
  TREES_RADIUS_VALIDATION_MIN,
  getFarTerrainLengthMax,
} from 'constants/geodata';

const isFiniteNumberInRange = (value: unknown, min: number, max: number) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= min && parsed <= max;
};

export const getFarTerrainLengthLimits = (resolution: unknown) => {
  const numericResolution = Number(resolution);

  if (FAR_TERRAIN_LENGTH_LIMITS_BY_RESOLUTION[numericResolution]) {
    return FAR_TERRAIN_LENGTH_LIMITS_BY_RESOLUTION[numericResolution];
  }

  if (numericResolution <= 30) {
    return FAR_TERRAIN_LENGTH_LIMITS_BY_RESOLUTION[30];
  }

  return {
    min: FAR_TERRAIN_LENGTH_LIMITS_BY_RESOLUTION[30].min,
    max: getFarTerrainLengthMax(numericResolution),
  };
};

export const isIntermediateTerrainLengthValid = (value: unknown) =>
  isFiniteNumberInRange(value, INTERMEDIATE_TERRAIN_LENGTH_LIMITS.min, INTERMEDIATE_TERRAIN_LENGTH_LIMITS.max);

export const getIntermediateTerrainLengthErrorMessage = () =>
  `Please enter a number between ${INTERMEDIATE_TERRAIN_LENGTH_LIMITS.min} and ${INTERMEDIATE_TERRAIN_LENGTH_LIMITS.max}`;

export const isFarTerrainLengthValid = (value: unknown, resolutionFar: unknown) => {
  const limits = getFarTerrainLengthLimits(resolutionFar);
  return isFiniteNumberInRange(value, limits.min, limits.max);
};

export const getFarTerrainLengthErrorMessage = (resolutionFar: unknown) => {
  const limits = getFarTerrainLengthLimits(resolutionFar);
  return `Please enter a number between ${limits.min} and ${limits.max}`;
};

export const isTreesRadiusValid = (value: unknown) =>
  isFiniteNumberInRange(value, TREES_RADIUS_VALIDATION_MIN, TREES_RADIUS_VALIDATION_MAX);
export const isTreesDonutRadiusValid = (value: unknown) =>
  isFiniteNumberInRange(value, TREES_RADIUS_VALIDATION_MIN, TREES_RADIUS_VALIDATION_MAX);
export const isTreesMinimalHeightValid = (value: unknown) =>
  isFiniteNumberInRange(value, TREES_MINIMAL_HEIGHT_VALIDATION_MIN, TREES_MINIMAL_HEIGHT_MAX);
export const isConcaveAlphaValueValid = (value: unknown) =>
  value == null ? true : isFiniteNumberInRange(value, TREES_RADIUS_VALIDATION_MIN, TREES_CONCAVE_ALPHA_MAX);

export const hasGeodataNumericValidationErrors = ({
  treesEnabled,
  lengthMid,
  lengthFar,
  resolutionFar,
  treesRadius,
  treesDonutRadius,
  treesMinimalHeight,
  concaveAlphaValue,
}: {
  treesEnabled: boolean;
  lengthMid: unknown;
  lengthFar: unknown;
  resolutionFar: unknown;
  treesRadius: unknown;
  treesDonutRadius: unknown;
  treesMinimalHeight: unknown;
  concaveAlphaValue: unknown;
}) =>
  !isIntermediateTerrainLengthValid(lengthMid) ||
  !isFarTerrainLengthValid(lengthFar, resolutionFar) ||
  (treesEnabled &&
    (!isTreesRadiusValid(treesRadius) ||
      !isTreesDonutRadiusValid(treesDonutRadius) ||
      !isTreesMinimalHeightValid(treesMinimalHeight) ||
      !isConcaveAlphaValueValid(concaveAlphaValue)));
